import {
  formatPaymentDuration,
  formatPaymentFee,
  formatProviderLimits,
  type PaymentProvider,
} from '@/domain/payments';
import { cn } from '@/lib/cn';

export interface PaymentInfoCardProps {
  provider: PaymentProvider;
  currency?: string;
  limitsLabel?: string;
  durationLabel?: string;
  feeLabel?: string;
  /** When set (e.g. after selecting a deposit bonus), override provider min/max display. */
  limitsOverride?: { MinAmount?: number | null; MaxAmount?: number | null } | null;
  className?: string;
}

export function PaymentInfoCard({
  provider,
  currency = '',
  limitsLabel = 'Limits',
  durationLabel = 'Duration',
  feeLabel = 'Fee',
  limitsOverride = null,
  className,
}: PaymentInfoCardProps) {
  const limitsSource = limitsOverride
    ? {
        MinAmount: limitsOverride.MinAmount ?? provider.MinAmount,
        MaxAmount: limitsOverride.MaxAmount ?? provider.MaxAmount,
      }
    : provider;
  const rows = [
    { label: limitsLabel, value: formatProviderLimits(limitsSource, currency) },
    { label: durationLabel, value: formatPaymentDuration(provider.Duration) },
    { label: feeLabel, value: formatPaymentFee(provider.Fee) },
  ];

  return (
    <div
      className={cn(
        'flex flex-col gap-2.5 rounded-xl border border-border-subtle bg-bg-surface px-4 py-3',
        className,
      )}
    >
      {rows.map((row) => (
        <div key={row.label} className="flex items-center justify-between gap-3 text-[13px]">
          <span className="text-text-secondary">{row.label}</span>
          <span className="font-medium text-text-primary">{row.value}</span>
        </div>
      ))}
    </div>
  );
}
